import wn from 'when'
import {call} from 'redux-saga/effects'
import request from './request'
import queryString from 'query-string'

const determineBody = (payload: any, options?: Object) =>
  options && options.headers && options.headers['content-type'] ? payload : JSON.stringify(payload)

function* get(endpoint: string, params?: object, options?: Object): Generator {
  return yield call(request, `${endpoint}?${queryString.stringify(params || {})}`, {...options, method: 'GET'})
}

function* patch(endpoint: string, payload: any, options?: Object): Generator {
  return yield call(request, endpoint, {...options, method: 'PATCH', body: determineBody(payload, options)})
}

function* post(endpoint: string, payload: any, options?: Object): Generator {
  return yield call(request, endpoint, {...options, method: 'POST', body: determineBody(payload, options)})
}

function* put(endpoint: string, payload: any, options?: object): Generator {
  return yield call(request, endpoint, {...options, method: 'PUT', body: determineBody(payload, options)})
}

function* delete_(endpoint: string, payload: any, options?: Object): Generator {
  return yield call(request, endpoint, {...options, method: 'DELETE', body: determineBody(payload, options)})
}

const methods = {get, post, put, patch, delete_}

// type CallEndpoint =
//   (<Return, Arg, Fn: (callable: Callables, arg: Arg) => Return>(fn: Fn, arg: Arg) => Return)
//   & (<Return, Fn: (callable: Callables) => Return>(fn: Fn) => Return)

/**
 * Takes an api function (anything found in $src/api/endpoints/*) and its arguments,
 * and runs that api function, returning either the success value or rejecting with the error.
 *
 * `callEndpoint` is also mockable, explained in ./__mocks__/callEndpoint.js
 */
export default function callEndpoint(fn: Function, ...args: Array<any>): any {
  return call(function*(): Generator {
    const callDeferred = wn.defer()
    const proxies: any = {}
    for (const method of ['get', 'post', 'put', 'patch', 'delete_']) {
      proxies[method] = (...args: any[]) => {
        // @ts-ignore
        callDeferred.resolve(call(methods[method], ...args))
      }
    }

    // @ts-ignore
    yield call(fn, proxies, ...args)
    const effect = yield callDeferred.promise
    return yield effect
  })
}



// WEBPACK FOOTER //
// ./src/api/sagas/callEndpoint.tsx